<template>
  <div class="edit-modal">
    <div
      class="backdrop"
      @click.self="$emit('close')"
    >
      <div class="modal">
        <form @submit.prevent="handleSubmit">
          <input
            v-model="displayName"
            type="text"
            :placeholder="record.displayName"
          >
          <select
            id="grade"
            v-model="grade"
            name="grade"
          >
            <option
              value=""
              disabled
              selected
              hidden
            >
              {{ record.grade }}
            </option>
            <option value="Baby Class">
              Baby Class
            </option>
            <option value="Reception Class">
              Reception
            </option>
            <option value="Grade 1">
              1
            </option>
            <option value="Grade 2">
              2
            </option>
            <option value="Grade 3">
              3
            </option>
            <option value="Grade 4">
              4
            </option>
            <option value="Grade 5">
              5
            </option>
            <option value="Grade 6">
              6
            </option>
            <option value="Grade 7">
              7
            </option>
          </select>
          <select
            id="role"
            v-model="role"
            name="role"
          >
            <option
              value=""
              disabled
              selected
              hidden
            >
              {{ record.role }}
            </option>
            <option value="learner">
              Learner
            </option>
            <option value="teacher">
              Teacher
            </option>
          </select>
          <input
            v-model="username"
            type="text"
            :placeholder="record.email.substr(0, record.email.length - 18)"
          >
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="password"
          >                    <label>
            <input
              v-model="showPassword"
              type="checkbox"
            >
            Show password
          </label>
          <div class="error">
            {{ error }}
          </div>
          <button>Update</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue' // , toRefs
import updateUser from '@/composables/updateUser'

export default {
  name: 'EditModal',
  props: ['record'],
  setup (props, context) {
    // const { record } = toRefs(props)
    // refs
    const displayName = ref('')
    const email = ref('')
    const username = ref('')
    const grade = ref('')
    const password = ref('')
    const role = ref('')
    const showPassword = ref(false)

    // updateUser
    const { error, updateUserCredential } = updateUser()

    const handleSubmit = async () => {
      const newPassword = password.value ? password.value : null
      const newEmail = username.value ? username.value + '@inspireschool.com' : props.record.email
      const newDisplayName = displayName.value ? displayName.value : props.record.displayName
      const newGrade = grade.value ? grade.value : props.record.grade
      const newRole = role.value ? role.value : props.record.role

      await updateUserCredential({ id: props.record.uid, email: newEmail, password: newPassword, displayName: newDisplayName, grade: newGrade, role: newRole })
      if (!error.value) {
        context.emit('newCredentialCreated')
        context.emit('close')
      }
    }

    return { displayName, email, password, handleSubmit, error, showPassword, username, grade, role }
  }
}
</script>

<style>
    .edit-modal .backdrop {
        top: 0;
        left: 0;
        position: fixed;
        background-color: fuchsia;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        /* z-index: 99; */
    }
    .edit-modal .modal {
        border-radius: 10px;
        max-width: 400px;
        background: #fff;
        padding: .5em;
    }
</style>
